export const StatesTabs = [
  { type: 'all', label: 'All' },
  { type: 'active', label: 'Active only' },
  { type: 'inactive', label: 'Inactive only' },
];
